import React, {memo} from 'react';
import ReactDOM from 'react-dom';
import { WbMarkdownHtml } from '../../utils/common';
import Portal from '../../styled-base/portal';
import {getOffset} from "../../utils/common";
import { useTranslation } from 'react-i18next';

const ConfidenceFlagHoverDetails = (props) => {
    const { t } = useTranslation();
    //var ds = document.getElementById(`confIt-${props.id}`);
    if (props.currentElement) {
        var d = getOffset(props.currentElement);
    } else {
        var d = getOffset(document.getElementById(`#confIt-${props.id}`));
    }
    let topValue = props.ofTop || props.ofTop == 0 ? props.ofTop : d.top ;//props.offsetTop;//
    let leftValue = props.ofLeft || props.ofLeft == 0 ? props.ofLeft : d.left;//props.offsetLeft;//
    let screenWidth = window.innerWidth - 350;
    let style = leftValue > 200 ? (leftValue < screenWidth ? {} : {marginLeft: '-375px'}) : {marginLeft: '-30px'};
    let arrowStyle = topValue - $(window).scrollTop() >250 ? {borderTop: '20px solid #666875', transform: 'translate(10px, -10px)'} : {borderBottom: '20px solid #666875'};
    let mainStyle =  topValue >250 ? { top: '25px'} : { marginTop: props.classProp == 'krRow' ? 2 : 5 };
    // if(topValue - $(window).scrollTop() > 250){
    //     mainStyle = {
    //         top: topValue - 225,
    //         left: leftValue - 2
    //     }
    // }else{
    //     mainStyle = {
    //         top: topValue + 5,
    //         left: leftValue - 2
    //     }
    // }
    
    // if(props.ofTop && topValue <250) {
    //     mainStyle = {
    //         marginTop: 10,
    //         top: props.ofTop
    //     }
    // }
    style.maxHeight = "190px";
    style.overflowY = "auto";
    Object.assign(mainStyle,{
        overflow: 'inherit',
        lineBreak: 'anywhere',
        marginLeft: props.classProp == 'krRow' ? '-23px': props.comingFromUpdateKr ? '-13px' : '-17px',
        marginTop: props.classProp == 'krRow' ? '2px' : props.comingFromUpdateKr ? '-15px' : '5px'
    });
    const {type,cDate,uName,comment} = props;
    return(
        <div className="confidence-hover-popup" id = 'confidence-hover-popup-tooltip' role='tooltip'>
            {(topValue - $(window).scrollTop() < 250 ? <div className="confidence-hover-head-pointer" style={arrowStyle} /> : '')}
            <div className="confidence-hover-body" style={style}>
                <div className="popupValueSection">
                    {type == 1 ? 'Low confidence' : type == 2 ? "Medium confidence" : type == 3 ? "High confidence" : ""}
                    {type != 0 ?  <span className="dotClass dotPopupStyling" /> : ''}
                    {t('As of')} {cDate} <span className="dotClass dotPopupStyling" /> {uName}
                </div>
                <div className="popupCommentSection"
                    dangerouslySetInnerHTML={WbMarkdownHtml(comment, true)}>
                </div>
            </div>
            {(topValue - $(window).scrollTop() >= 250 ? <div className="confidence-hover-head-pointer" style={arrowStyle} /> : '')}
        </div>
    )
}

export default memo(ConfidenceFlagHoverDetails);

const initConfidenceFlag = function(data, el) {
    if(el)
        data.currentElement = el;
    ReactDOM.render(
        <Portal position={data.position} centerY={false}>
            <div>
                <ConfidenceFlagHoverDetails
                    {...data}
                />
            </div>
        </Portal>, 
        el
    );
}

const removeConfidenceFlag = function(id) {
    // if (document.getElementById('confidenceKRFlagHeatmap-'+id)) {
    //     ReactDOM.unmountComponentAtNode(document.getElementById('app-portal-container'));
    // }
    ReactDOM.unmountComponentAtNode(document.getElementById('app-portal-container'));
}
window.initConfidenceFlag = initConfidenceFlag;
window.removeConfidenceFlag = removeConfidenceFlag;